import  React from 'react'
import Datetime from 'react-datetime'
import moment from 'moment';
import _ from 'lodash';
import { Field } from 'redux-form';
export const fields = {
    stepTwo: [
        {
            name: "Arcada Superior",
            active: false,
            items: [
                {name: "Expansionar", active: true, input: false},
                {name: "Extruir", active: true, input: false},
                {name: "Comprimir", active: true, input: false},
                {name: "Rotar", active: true, input: false},
                {name: "Cerrar de espacios", active: true, input: false},
                {name: "Dar torque", active: true, input: false},
                {name: "Protuir", active: true, input: false},
                {name: "Dar angulación TIP", active: true, input: false},
                {name: "Retruir", active: true, input: false},
                {name: "Mesializar", active: true, input: false},
                {name: "Intruir", active: true, input: false},
                {name: "Distalar", active: true, input: false}
            ]
        },
        {
            name: "Arcada Inferior",
            active: false,
            items: [
                {name: "Expansionar", active: true, input: false},
                {name: "Extruir", active: true, input: false},
                {name: "Comprimir", active: true, input: false},
                {name: "Rotar", active: true, input: false},
                {name: "Cerrar de espacios", active: true, input: false},
                {name: "Dar torque", active: true, input: false},
                {name: "Protuir", active: true, input: false},
                {name: "Dar angulación TIP", active: true, input: false},
                {name: "Retruir", active: true, input: false},
                {name: "Mesializar", active: true, input: false},
                {name: "Intruir", active: true, input: false},
                {name: "Distalar", active: true, input: false}
            ]
        }
    ],
    stepThree: {
        fields: [
            {
                name: "Corrección espacios Bolton",
                active: false,
                items: [
                    {name: "Dejar diastema en", active: true, input: false},
                    {name: "Repartir espacios en 4 incisivos", active: true, input: false},
                    {name: "Stripping en arcada opuesta", active: true, input: false}
                ]
            },
            {
                name: "Centrar linea media",
                active: false,
                disabled: true,
                type:"group",
                items: [
                    {
                        name: "Desviación superior",
                        type:"group",
                        input: false,
                        items: [
                                    {name: "Dch.", type:"checkbox"},
                                    {name: "Ok", type:"checkbox"},
                                    {name: "Izq.", type:"checkbox"}
                        ]
                    },
                    {
                        name: "Desviación inferior",
                        type:"group",
                        input: false,
                        items: [
                                    {name: "Dch.", type:"checkbox"},
                                    {name: "Ok", type:"checkbox"},
                                    {name: "Izq.", type:"checkbox"}
                        ]
                    }
                ]
            },
            {
                name: "Correción anteroposterior",
                active: false,
                items: [
                    {name: "Elásticos", active: true, input: false},
                    {name: "Stripping sectores laterales", active: true, input: false}
                ]
            },
            {
                name: "Piezas protésicas",
                active: false,
                type: "radio",
                items: [
                    {name: "Implantes", active: true, input: false, placeholder: "Indicar piezas"},
                    {name: "Coronas", active: true, input: false, placeholder: "Indicar piezas"},
                    {name: "Puentes", active: true, input: false, placeholder: "Indicar piezas"},
                    {name: "Colocar piezas en esp. edéntulos", active: true, input: false, placeholder: "Indicar piezas"}
                ]
            },
            {
                name: "Stripping",
                active: false,
                desc: "indicaciones",
                items: []
            },
            {
                name: "Microtornillos",
                active: false,
                desc: "indicar posición",
                items: []
            },
            {
                name: "​Rampas de mordida",
                active: false,
                desc: "indicaciones",
                items: []
            },
            {
                name: "​Sobrecorrección",
                active: false,
                desc: "indicar posición",
                items: []
            }
        ],
        aux: {
            name: "Elementos auxiliares",
            type: "group",
            value: "no",
            options: [
                {
                    name: "Colocación de elementos auxiliares donde sea necesario",
                    value: "no"
                },
                {
                    name: "Indicación expresa de los elementos auxiliares",
                    value: "si"
                }
            ],
            items: [
                {
                    name: "Ataches",
                    active: false,
                    disabled: true,
                    items: [
                        {name: "Rotación", active: true, input: false},
                        {name: "Retención", active: true, input: false},
                        {name: "Extrusión", active: true, input: false},
                        {name: "Mov. mesiodistales", active: true, input: false}
                    ]
                },
                {
                    name: "Pestaña para elásticos",
                    active: false,
                    disabled: true,
                    desc: "indicar piezas",
                    items: []
                },
                {
                    name: "Elásticos",
                    active: false,
                    disabled: true,
                    type:"group",
                    items: [
                        {
                            name: "Mordida cruzada",
                            type:"group",
                            items: [
                                {
                                    name: "Clase II",
                                    type:"group",
                                    items: [
                                        {name: "Dch.", type:"checkbox"},
                                        {name: "Izq.", type:"checkbox"}
                                    ]
                                },
                                {
                                    name: "Clase III",
                                    type:"group",
                                    items: [
                                        {name: "Dch.", type:"checkbox"},
                                        {name: "Izq.", type:"checkbox"}
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Mordida abierta",
                            type:"group",
                            items: [
                                {
                                    name: "Anterior",
                                    type:"group",
                                    items: [
                                        {name: "Si", type:"checkbox"}
                                    ]
                                },
                                {
                                    name: "Posterior",
                                    type:"group",
                                    items: [
                                        {name: "Dch.", type:"checkbox"},
                                        {name: "Izq.", type:"checkbox"}
                                    ]
                                }

                            ]
                        }
                    ]
                },
                {
                    name: "Recortado para botones",
                    active: false,
                    disabled: true,
                    desc: "indicar piezas",
                    items: []
                }
            ]
        }
    }
}
export const renderCal = (field, { input }) => {
    const yesterday = Datetime.moment().subtract(1, 'day');
    const valid = function( current ){
        if(!field.limit){
            return current.isAfter( yesterday );
        }else{
            return current.isAfter( moment(field.limit).format() );
        }
    };
    const renderInput = (props, openCalendar) => {
        return(
        <div className="input-group">
            <input
                className="form-control"
                disabled={field.disabled}
                {...props}
            />
            <a onClick={openCalendar} className="input-group-addon">
                <i className="fa fa-calendar" />
            </a>
        </div>
        )
    }

    return(
        <div className={field.col ? "form-group " + field.col : "form-group"}>
            <label>{field.label}</label>
            <Datetime
                timeFormat={false}
                renderInput={ renderInput }
                isValidDate={ valid }
                closeOnSelect={true}
                {...field.input}
            />
            {field.warnText && <span className="text-warning">{field.warnText}</span>}
            {field.meta.touched && field.meta.error && <span className="text-danger">{field.meta.error}</span>}
        </div>
    )
}
export const renderInput = (field) => {
    return(
        <div className={field.col ? "form-group " + field.col : "form-group"}>
            {field.label && <label>{field.label}</label>}
            <input
                className="form-control"
                type={field.type}
                disabled={field.disabled}
                {...field.input}
            />
            {field.meta.touched && field.meta.error && <span className="text-danger">{field.meta.error}</span>}
        </div>
    )
}
export const renderSpecialInput = (field) => {
    function auto_grow() {
        let element = document.getElementsByName(field.input.name)[0]
        if(element){
            element.style.height = (element.scrollHeight)+"px";
        }
    }
    return(
        <div className={field.col ? "form-group " + field.col : "form-group"}>
            {field.label && <label>{field.label}</label>}
            <textarea
                placeholder={field.placeholder || null}
                onKeyUp={auto_grow()}
                className="form-control"
                disabled={field.disabled}
                rows={1}
                {...field.input}
            />
            {field.meta.touched && field.meta.error && <span className="text-danger">{field.meta.error}</span>}
        </div>
    )
}
export const renderTextArea = (field) => {
    return(
        <div className={field.col ? "form-group " + field.col : "form-group"}>
            {field.label && <label>{field.label}</label>}
            <textarea
                placeholder={field.placeholder || null}
                className="form-control"
                disabled={field.disabled}
                rows={field.rows || 10}
                {...field.input}
            />
            {field.meta.touched && field.meta.error && <span className="text-danger">{field.meta.error}</span>}
        </div>
    )
}
export const renderCheckbox = (field) => {
    return(
        <div className={field.col ? "form-check " + field.col : "form-check"}>
            <label className={field.disabled ? "form-check-label disabled" : "form-check-label" }>
                <input
                    className="form-check-input"
                    type="checkbox"
                    checked={field.input.value}
                    disabled={field.disabled}
                    {...field.input} />
                {field.label}
            </label>
            {field.meta.touched && field.meta.error && <span className="text-danger">{field.meta.error}</span>}
        </div>
    )
}
export const renderRadio = (field) => {
    return(
        <div className="form-check form-check-inline">
            <label className="form-check-label">
                <input
                    type="radio"
                    className="form-check-input"
                    {...field.input}
                />
                {field.label}
            </label>
            {field.meta.touched && field.meta.error && <span className="text-danger">{field.meta.error}</span>}
        </div>
    )
}


// WEBPACK FOOTER //
// ./resources/assets/js/components/forms/newcaso/Fields.jsx